var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(!_vm.dataIsReady)?_c('LoadingComp',{key:"loadingComp"}):_vm._e(),(_vm.dataIsReady)?_c('router-view',{key:"routerView"}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }